import React, { useEffect, useRef } from 'react';
import * as skinview3d from 'skinview3d';

export default function SkinViewer({ username, width = 150, height = 250, animation = 'idle' }) {
  const canvasRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const skinUrl = `https://mc-heads.net/skin/${username}`;

    const viewer = new skinview3d.SkinViewer({
      canvas: canvasRef.current,
      width,
      height,
      skin: skinUrl,
    });

    viewer.autoRotate = true;
    viewer.autoRotateSpeed = 1.0;
    viewer.zoom = 0.9;
    viewer.fov = 30;

    // Disable zoom
    viewer.controls.enableZoom = false;

    // Set background transparent
    viewer.renderer.setClearColor(0x000000, 0);

    // Animation
    if (animation === 'idle') {
      viewer.animation = new skinview3d.IdleAnimation();
    } else if (animation === 'walk') {
      viewer.animation = new skinview3d.WalkingAnimation();
    } else if (animation === 'run') {
      viewer.animation = new skinview3d.RunningAnimation();
    }

    viewerRef.current = viewer;

    return () => {
      viewer.dispose();
    };
  }, [username, width, height, animation]);

  return (
    <canvas
      ref={canvasRef}
      style={{ imageRendering: 'auto' }}
    />
  );
}
